import React from "react";
import Help from "./Help";
import SysStatsCpuReport from "./Report";
import View from "common/View";

const SysStatsCpu = () => (
  <View title="CPU Usage Over Time" Help={Help}>
    <SysStatsCpuReport />
  </View>
);

export default SysStatsCpu;
